import React, { lazy, Suspense, useEffect } from "react";

//routing imports
import { Redirect, Route, Router, Switch } from "react-router-dom";

//HMR
import { hot } from "react-hot-loader";

import { useParams, useLocation } from "react-router-dom";

//components static

import history from "./history";

import { frontEnd } from "./config/links";

//import LogRocket from "logrocket";

import Http404Page from "./pages/http404page";

// import Profile from "./pages/authorization/profile";
// import ResetPassword from "./pages/authorization/reset-password";
import Home from "./pages/home";
import Purchase from "./pages/Dashboard/purchase";
import { useUserContext } from "./context/user-context";
import { appFetch } from "./helpers/app-fetch";
import useCaptureRefTag from "./helpers/use-capture-ref-tag";
const Header = lazy(() => import("./components/header/header"));
const BlogPage = lazy(() => import("./pages/blog"));
const Footer = lazy(() => import("./components/footer/footer"));
const BlogPostPage = lazy(() => import("./pages/blog/[slug]"));
const ExamBlogPage = lazy(() => import("./pages/blog/exam-blog"));

//
//dashbaord pages
//
// import Revise from "./pages/Dashboard/revise";
//LogRocket.init("zdz1em/getthru");

const ResendConfirmEmail = lazy(() =>
  import("./pages/authorization/resend-confirm-email")
);
const Admin = lazy(() => import("./pages/admin"));
const Profile = lazy(() => import("./pages/authorization/profile"));
const ResetPassword = lazy(() =>
  import("./pages/authorization/reset-password")
);
const ConfirmEmail = lazy(() => import("./pages/authorization/confirm-email"));
const Revise = lazy(() => import("./pages/Dashboard/revise"));
const Review = lazy(() => import("./pages/Dashboard/review"));
const ReviewReport = lazy(() => import("./pages/admin/review-report"));

const SingleUpload = lazy(() => import("./pages/admin/addQuestion"));
const BulkUpload = lazy(() => import("./pages/admin/bulk-upload"));
const ExamEnd = lazy(() => import("./pages/Dashboard/examEnd"));
const ExamReview = lazy(() => import("./pages/Dashboard/examReview"));
const Results = lazy(() => import("./pages/Dashboard/results"));
const Dashboard = lazy(() => import("./pages/Dashboard/dashboard-wrapper"));
const DashboardHome = lazy(() => import("./pages/Dashboard/home"));
const ExamsList = lazy(() => import("./pages/Dashboard/exams"));
const ExamDetail = lazy(() => import("./pages/Dashboard/exams/exam-detail"));
const StudyGuide = lazy(() => import("./pages/Dashboard/study-guide"));

// ApolloShell is lazy so @apollo/client stays out of main.js
const ApolloShell = lazy(() => import("./graphql/ApolloShell"));

const GSSE = lazy(() => import("./pages/gsse"));
const BPS = lazy(() => import("./pages/bps"));
const GPEPAU = lazy(() => import("./pages/gpep/au"));
const GPEPNZ = lazy(() => import("./pages/gpep/nz"));
const TermsAndConditions = lazy(() => import("./pages/legal/terms"));
const PrivacyPolicy = lazy(() => import("./pages/legal/privacy-policy"));
const CookiePolicy = lazy(() => import("./pages/legal/cookie-policy"));

const App = () => {
  return (
    <Router history={history}>
      <RefTagTracker />
      {/* <NavBar /> */}
      <Suspense fallback={<div></div>}>
        <Switch>
          <Route
            path="/(login/index.html|register/index.html|login|register|register-success|forgot-password|forgot-password/index.html|confirm-email|confirm-email/index.html|closed-for-alpha|resend-confirm-email|reset-password|)/"
            component={Home}
          />
          <Route path={frontEnd.profile} exact component={Profile} />

          <Route
            path={[
              frontEnd.bulkUpload,
              frontEnd.reviewReports,
              frontEnd.singleUpload,
              frontEnd.results,
              frontEnd.review
            ]}
          >
            <ApolloShell>
              <Switch>
                <Route
                  path={frontEnd.bulkUpload}
                  exact
                  component={BulkUpload}
                />
                <Route
                  path={frontEnd.reviewReports}
                  exact
                  component={ReviewReport}
                />
                <Route
                  path={frontEnd.singleUpload}
                  exact
                  component={SingleUpload}
                />
                <Route path={frontEnd.results} component={Results} />
                <Route path={frontEnd.review} exact component={Review} />
              </Switch>
            </ApolloShell>
          </Route>

          <Route
            path="/study-guide-preview"
            component={StudyGuidePreviewPage}
          />
          <Route path="/blog" exact component={BlogPageWithLayout} />
          <Route path="/blog/gsse" exact component={ExamBlogPageWithLayout} />
          <Route path="/blog/bps" exact component={ExamBlogPageWithLayout} />
          <Route path="/blog/gpepau" exact component={ExamBlogPageWithLayout} />
          <Route path="/blog/:slug" component={BlogPostPageWithLayout} />

          <Route path={frontEnd.admin} exact component={Admin} />
          <Route path={frontEnd.confirmEmail} exact component={ConfirmEmail} />
          <Route
            path={frontEnd.resendConfirmEmail}
            component={ResendConfirmEmail}
          />
          <Route
            path={frontEnd.resetPassword}
            exact
            component={ResetPassword}
          />
          {/* <Route path={frontEnd.forgotPassword} component={ForgotPassword} /> */}
          <Route path="/dashboard">
            <DashboardRoutes />
          </Route>
          <Route path={frontEnd.gsse} component={GSSE} />
          <Route path={frontEnd.bps} component={BPS} />
          <Route path={frontEnd.gpepau} component={GPEPAU} />
          <Route path={frontEnd.gpepnz} component={GPEPNZ} />
          <Route path="/terms" exact component={TermsPageWithLayout} />
          <Route
            path="/privacy-policy"
            exact
            component={PrivacyPageWithLayout}
          />
          <Route path="/cookie-policy" exact component={CookiePageWithLayout} />
          <Route component={Http404Page} />
        </Switch>
        <Switch></Switch>
      </Suspense>
    </Router>
  );
};

const RefTagTracker = () => {
  useCaptureRefTag();
  return null;
};

const DashboardRoutes = () => {
  const { userState } = useUserContext();

  useEffect(() => {
    let checkIfUserIsActive = async () => {
      let response = await appFetch("/api/auth/validate", {
        method: "GET"
      });

      console.log(response);
    };
    if (!userState?.attributes?.checkedIfUserLoggedIn) {
      checkIfUserIsActive();
    }
  }, [userState?.attributes?.checkedIfUserLoggedIn]);

  if (!userState?.attributes?.exam) {
    return null;
  }
  return (
    <ApolloShell>
      <Dashboard>
        <Suspense fallback={<div></div>}>
          <Switch>
            <Route path={frontEnd.dashboardHome} component={DashboardHome} />
            <Route path={frontEnd.revise} exact component={Revise} />
            <Route path={frontEnd.testResults} exact component={ExamEnd} />
            <Route path={frontEnd.examReview} exact component={ExamReview} />
            <Route path={frontEnd.purchase} exact component={Purchase} />
            <Route path={frontEnd.examDetail} exact component={ExamDetail} />
            <Route path={frontEnd.exams} exact component={ExamsList} />
            {userState?.attributes?.roles?.includes("Admin") ? (
              <Route path={frontEnd.studyGuide} component={StudyGuide} />
            ) : (
              <Route
                path={frontEnd.studyGuide}
                render={() => <Redirect to={frontEnd.dashboardHome} />}
              />
            )}
          </Switch>
        </Suspense>
      </Dashboard>
    </ApolloShell>
  );
};

const BlogPageWithLayout = () => (
  <>
    <Header />
    <BlogPage />
    <Footer />
  </>
);

const BlogPostPageWithLayout = () => {
  const { slug } = useParams<{ slug: string }>();
  return (
    <>
      <Header />
      <BlogPostPage params={{ slug }} />
      <Footer />
    </>
  );
};

const ExamBlogPageWithLayout = () => {
  const location = useLocation();
  const examType = location.pathname.split("/").pop();
  return (
    <>
      <Header />
      <ExamBlogPage examType={examType} />
      <Footer />
    </>
  );
};

const TermsPageWithLayout = () => (
  <>
    <Header />
    <TermsAndConditions />
    <Footer />
  </>
);

const PrivacyPageWithLayout = () => (
  <>
    <Header />
    <PrivacyPolicy />
    <Footer />
  </>
);

const CookiePageWithLayout = () => (
  <>
    <Header />
    <CookiePolicy />
    <Footer />
  </>
);

const StudyGuidePreviewPage = () => (
  <div
    style={{
      backgroundColor: "rgb(244, 246, 255)",
      minHeight: "100vh",
      padding: 24,
      display: "flex",
      flexDirection: "column",
      alignItems: "stretch"
    }}
  >
    <div
      style={{
        background: "#fff4d6",
        color: "#664600",
        border: "1px solid #f1d888",
        borderRadius: 10,
        padding: "10px 16px",
        marginBottom: 16,
        fontSize: 13
      }}
    >
      <strong>Preview mode.</strong> This is an unauthenticated demo of the
      Study Guide. Progress is saved in localStorage only.
    </div>
    <StudyGuide isPreview={true} />
  </div>
);

export { history };

//@ts-ignore

export default hot(module)(App);
